import { useContext, useState } from 'react';

import './styles.css';
import useOverlay from 'hooks/useOverlay';
import usePromoAsset from 'hooks/usePromoAsset';
import UserContext from 'contexts/UserContext';

function PopupWelcome() {
    const { currentPromo } = useContext(UserContext);
    const [open, setOpen] = useState(localStorage.getItem('firstTime') === 'true');
    useOverlay(open);

    const { asset: logo } = usePromoAsset(currentPromo, 'logo.png');

    const handleClose = () => {
        localStorage.removeItem('firstTime');
        setOpen(false);
    }

    return (
        open ? 
            <div className="overlay">
                <div className="popup-success-container">
                    <img src={logo} alt="banner-week" className="popup-success-img" />
                        <p className="popup-success-title">Falta pouco!</p>
                        <p className="popup-success-subtitle">Cadastro efetuado com sucesso!</p>
                        <p className="popup-success-subsubtitle">Você precisa fazer um pedido pelo Juntos+ para participar da promoção</p>
                        <p className="popup-success-cta" onClick={handleClose}>Ok, entendi</p>
                </div>
            </div> : <></>
    )
}

export default PopupWelcome;